import { Fragment } from "react";

const flow = [
  { icon: "ri-image-line", label: "Foto", text: "o prato existe" },
  { icon: "ri-play-line", label: "Movimento", text: "ganha vida" },
  { icon: "ri-fire-line", label: "Desejo", text: "dá vontade" },
  { icon: "ri-checkbox-circle-line", label: "Decisão", text: "ele escolhe" },
  { icon: "ri-shopping-bag-line", label: "Pedido", text: "vira venda" },
];

export default function DesireFlow() {
  return (
    <section className="grain relative overflow-hidden bg-foreground-950 py-16 md:py-20">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,oklch(var(--primary-500)/0.12),transparent_65%)]" />

      <div className="relative z-10 mx-auto max-w-6xl px-4 md:px-6">
        <p className="reveal mb-10 text-center text-xs font-bold uppercase tracking-[0.28em] text-foreground-500 md:mb-14">
          A lógica por trás de cada pedido
        </p>

        <div className="reveal flex flex-col gap-6 md:flex-row md:flex-nowrap md:items-start md:justify-center md:gap-4">
          {flow.map((step, i) => (
            <Fragment key={step.label}>
              <div className="flex items-center gap-4 md:flex-1 md:flex-col md:gap-3 md:text-center">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-primary-500/40 bg-primary-500/10 text-primary-500 md:h-16 md:w-16">
                  <i className={`${step.icon} text-xl md:text-2xl`} aria-hidden="true" />
                </span>
                <div className="md:mt-1">
                  <p className="whitespace-nowrap font-heading text-base font-bold text-foreground-50 md:text-lg">
                    {step.label}
                  </p>
                  <p className="whitespace-nowrap text-xs text-foreground-500 md:text-sm">
                    {step.text}
                  </p>
                </div>
              </div>

              {i < flow.length - 1 && (
                <span
                  className="hidden shrink-0 items-center justify-center self-center text-primary-500/60 md:flex"
                  aria-hidden="true"
                >
                  <i className="ri-arrow-right-line text-xl" />
                </span>
              )}
            </Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}